<template>
  <v-dialog v-model="dialog" max-width="600" min-width="300">
    <v-card >
      <card-header :title="title" :icon="icon" color="primary" variant="gradient"></card-header>
      <v-card-text>
        <v-container>
          <v-row class="mt-5">
            <v-col v-for="[key, value] in Object.entries(data)" :key="key" align="center" dense cols="12">
              <v-text-field :label="value.label" v-model="value.value" readonly dense outlined
                hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="justify-end mr-3 mb-3">
        <custom-button 
        @click="closeModal" 
        :label="closeMessage" color="primary" size="lg" gradient
          rounded></custom-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import CardHeader from "@/components/cards/CardHeader.vue";
  import CustomButton from '@/components/common/buttons/CustomButton.vue';

  export default {
    components: {
      CardHeader,
      CustomButton,
    },
    props: {
      title: {
        type: String,
        required: false,
        default: "상세보기",
      },
      icon: {
        type: String,
        required: false,
        default: "mdi-magnify",
      },
      data: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      closeMessage: {
        type: String,
        required: false,
        default: "닫기",
      },
      isVisible: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      dialog: {
        get() {
          return this.isVisible;
        },
        set(value) {
          if (!value) this.$emit("close");
        },
      },
    },
    methods: {
      closeModal() {
        this.$emit("close");
      },
    },
  };
</script>

<style scoped>
.v-card {
  overflow: hidden; 
}
</style>

